export const pillars = ['Saha operasyonları', 'Olay yeri ve delil', 'Hukuki güvenceler', 'İstihbarat ve analiz', 'Kriz müdahalesi', 'İdari verimlilik'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'Saha Operasyonları (Vardiya Sonu Raporlama Sistemi)',
  desc: 'Saha müdahaleleri, olayların kronolojik anlatımı, trafik olayları, gözaltı ve yakalama işlemlerine ilişkin kayıtlar ve vardiya sonu raporları için yapılandırılmış komutlar kullanın. Bilgileri daha anlaşılır biçimde düzenleyin ve raporlama sürecinizi kolaylaştırın.'
}, {
  n: 2,
  emoji: '📔',
  title: 'Olay Yeri ve Delil Belgelendirme (Soruşturma ve Belge İnceleme Paketi)',
  desc: 'Olay yeri betimlemeleri, delil envanterleri, belge referansları ve teslim-tesellüm kayıtlarının düzenlenmesine yardımcı olacak komutlardan yararlanın. Kaynakların izlenebilirliğini ve kayıtların tutarlılığını sistematik biçimde kontrol edin.'
}, {
  n: 3,
  emoji: '📕',
  title: 'Hukuki Güvenceler ve Mevzuata Uygunluk (Belge ve Mevzuat Kontrol Sistemi)',
  desc: 'Raporlarda hukuki açıdan doğrulanması gereken noktaları belirlemek, belgelerdeki eksiklikleri gözden geçirmek ve mevzuat referanslarını kontrol için yapılandırmak üzere tasarlanmış komutları kullanın. Türk hukukuna ilişkin referansların güncel ve doğru kaynaklardan doğrulanması gerekir.'
}, {
  n: 4,
  emoji: '📓',
  title: 'İstihbarat ve Önleyici Analiz (Önleyici Analiz ve Bilgi Düzenleme Sistemi)',
  desc: 'Yetkili kaynaklardan elde edilen bilgileri özetleyin, olay eğilimlerini yapılandırılmış biçimde inceleyin ve vardiya bilgilendirmeleri hazırlayın. Kaynakların izlenebilirliğini koruyun ve doğrulanmamış çıkarımları kesin bilgi gibi sunmaktan kaçının.'
}, {
  n: 5,
  emoji: '📗',
  title: 'Kriz Müdahalesi ve Hassas Olaylar (Kriz Belgeleme ve Müdahale Kayıtları)',
  desc: 'Kriz olayları, müdahale süreçleri, güç kullanımı kayıtları ve mağdurlara sağlanan yardımlarla ilgili belgeleri daha düzenli hazırlayın. Olayları nesnel biçimde kaydedin; eksik bilgileri tahminle doldurmayın ve gerçekleşmiş olayları sonradan gerekçelendirmek için değiştirmeyin.'
}, {
  n: 6,
  emoji: '📙',
  title: 'İdari Verimlilik ve Mesleki Gelişim (İdari İş Akışı ve Belge Yönetimi)',
  desc: 'İç yazışmalar, görev devir teslimleri, bekleyen işlemler, yönetim raporları ve idari belge hazırlığı için pratik komutlar kullanın. Tekrarlanan işleri daha düzenli bir iş akışına dönüştürün.'
}];
export const volumeIncludes = ['Adım adım uygulanabilen kopyala-yapıştır yapay zekâ komutları', 'Hızlı özelleştirme için doldurulabilir alanlar', 'Raporlama terminolojisine yönelik açıklamalar', 'Belge inceleme ve kalite kontrol kontrol listeleri', 'Eksik bilgi ve doğrulama gerektiren noktaları belirlemeye yardımcı yönergeler'];
export const bonuses = [{
  n: '01',
  title: 'Vücut Kamerası Raporlama Rehberi™',
  subtitle: 'Kaydı Raporlama Sürecine Dönüştürme Sistemi',
  desc: 'Ses dökümlerini, zaman damgalarını, konuşmacı etiketlerini ve kaynak referanslarını düzenlemeye yönelik yapılandırılmış komutlardan yararlanın.',
  price: '1.580 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/6AGVutZNXAdCrunES7nHgN/Guia_de_Reportes_con_Camara_Corporal.webp'
}, {
  n: '02',
  title: 'Duruşma ve Tanık İfadesi Hazırlık Rehberi™',
  subtitle: 'Belge İnceleme ve Kronoloji Organizasyon Sistemi',
  desc: 'Mevcut belgeleri, olay kronolojisini ve kaynak referanslarını daha düzenli biçimde inceleyin. İfadelerin anlamını değiştirmeden tutarsızlıkları ve açıklığa kavuşturulması gereken noktaları belirleyin.',
  price: '1.435 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/utA7YPxRhFEuw4hn1k6RM9/Guia_de_Reportes_con_Camara_Corporal_(1).webp'
}, {
  n: '03',
  title: 'Vardiya ve Devir Teslim Komuta Kiti™',
  subtitle: 'Vardiya Özeti ve Görev Takip Sistemi',
  desc: 'Vardiya özetlerini, açık görevleri, bekleyen idari işlemleri ve bir sonraki vardiyaya aktarılacak bilgileri yapılandırılmış bir formatta düzenleyin.',
  price: '1.580 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/kCVRv67zhM2XV9wEqJzjmj/Guia_de_Reportes_con_Camara_Corporal_(2).webp'
}, {
  n: '04',
  title: 'Rapor Kalitesi ve Hata Denetim Kiti™',
  subtitle: 'Eksik Alanlar ve Tutarlılık Kontrol Sistemi',
  desc: 'Raporlardaki eksik alanları, kronoloji sorunlarını, kaynak farklılıklarını ve doğrulanması gereken bilgileri sistematik biçimde gözden geçirin.',
  price: '1.330 TRY',
  cover: 'https://cdn.magicpatterns.com/uploads/dEKD9YyNhagZBjcH8xAa7T/Guia_de_Reportes_con_Camara_Corporal_(3).webp'
}];
